import React, { memo } from "react"
import PracticeLogo from "./PracticeLogo"
import PracticeName from "./PracticeName"
import { StyledPracticeLogoNameWrapper } from "./style"
import { PracticeBarProps } from "./types"

function PracticeBar({ practice }: PracticeBarProps): JSX.Element {
  return (
    <StyledPracticeLogoNameWrapper>
      <PracticeLogo practice={practice} />
      <PracticeName practice={practice} />
    </StyledPracticeLogoNameWrapper>
  )
}

export default memo(PracticeBar)
